import { MainV3ApiBase } from './base';
import { SubmittedEvaluationBlock } from '../../adminv3/types/courseExams';
import { SubmitFieldState } from '../../commonv3/types/course_works';
import { ExamPracticalSectionSubmissionToken } from '../../commonv3/types/courseExams';

export const SubmissionEvaluationResultApis = {
  show(submissionToken: ExamPracticalSectionSubmissionToken) {
    return MainV3ApiBase.appendPath('practical_section_submissions')
      .appendPath(submissionToken)
      .appendPath('submission_evaluation_result')
      .get();
  },

  create(
    submissionToken: ExamPracticalSectionSubmissionToken,
    submittedevaluationBlocks: SubmittedEvaluationBlock[],
    submittedReviewFields: SubmitFieldState[]
  ) {
    return MainV3ApiBase.appendPath('practical_section_submissions')
      .appendPath(submissionToken)
      .appendPath('submission_evaluation_results')
      .post({
        submitted_evaluation_blocks: submittedevaluationBlocks,
        submitted_review_fields: submittedReviewFields,
      });
  },
};
